import { HTMLAttributes } from 'react';
import classNames from 'classnames';
import './AvatarContainer.scss';

export type AvatarContainerSize = 'large' | 'medium' | 'small' | 'xs' | '2xs' | '3xs' | '4xs';

export interface AvatarContainerProps extends HTMLAttributes<HTMLDivElement> {
  /** Let the parent layout set dimensions; used by ImageAvatar / InteractiveAvatar fill mode */
  fill?: boolean;
  size?: AvatarContainerSize;
}

export const AvatarContainer: React.FC<AvatarContainerProps> = ({
  children,
  className,
  fill,
  size,
  style,
  ...rest
}) => (
  <div
    className={classNames(
      'vds-avatar-container',
      fill && 'vds-avatar-container--fill',
      !fill && size && `vds-avatar-container--${size}`,
      className,
    )}
    style={style}
    {...rest}>
    {children}
  </div>
);
